<gl-cards-page-layout-container>
    <ng-container *ngTemplateOutlet="headerTemplate" header></ng-container>
    <rwidget-cards-list class="flex flex-col gap-4" main-1></rwidget-cards-list>
    <rwidget-cards-actions desktop-header-sub-content></rwidget-cards-actions>
    <rwidget-cards-actions mobile-bottom></rwidget-cards-actions>
</gl-cards-page-layout-container>

<ng-template #headerTemplate>
    <!-- MOBILE -->
    <div
        class="pn-app-light:bg-white pil-light-dark:bg-white tartu-light:bg-white tallinn-light:bg-white mb-3 grid w-full grid-cols-[4rem_1fr_4rem] bg-primary py-3 dark:bg-contrast-black md:hidden">
        <div></div>
        <div class="flex items-center justify-center">
            <h1 class="pil-light-dark:!text-secondary text-base font-semibold">{{ 'APP_MENU_CARD' | translate }}</h1>
        </div>
        <ion-button
            class="text-xs font-semibold normal-case text-secondary"
            [attr.aria-label]="'ADD' | translate"
            (click)="navigateToAddCard()"
            fill="clear">
            <svg
                class="pn-app-light:fill-primary pil-light-dark:!fill-secondary dark:fill-contrast-yellow"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M10 0V22H12V0H10Z" />
                <path d="M22 10L4.19617e-05 10V12L22 12V10Z" />
            </svg>
        </ion-button>
    </div>

    <!-- DESKTOP -->
    <h1 class="hidden text-base md:block md:text-[2.75rem]">{{ 'APP_MENU_CARD' | translate }}</h1>
</ng-template>
